/* ONX live reviews: upgrades the server rendered rating and review cards with Klaviyo's public data.
   Everything is optional: the page already contains a real snapshot, any failure keeps it as is.
   Hooks: [data-onx-rating] [data-onx-count] (every page), [data-onx-rev-live] section with .onx-rev__card
   (home). One cookieless GET (3 s timeout), cached 12 h in localStorage. */
(function () {
  'use strict';
  var w = window, d = document, K = 'onx_rv1', TTL = 432e5, WAIT = 9e5, ST = null, done = 0;
  var U = 'https://fast.a.klaviyo.com/reviews/api/client_reviews/all/?product_id=all&company_id=THCVrG&offset=0&sort=3&type=reviews&subtype=all&media=false&limit=';
  var C = {};
  try { C = JSON.parse(w.localStorage.getItem(K)) || {}; } catch (e) { C = {}; }
  function save() { try { w.localStorage.setItem(K, JSON.stringify(C)); } catch (e) {} }
  function all(s) { return d.querySelectorAll(s); }
  function fresh(t) { return t && Date.now() - t < TTL; }

  function clean(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }
  function nm(n) { n = clean(n).replace(/\s*\(L&R Pair\)/i, '').replace(/\sI\s/, ' | '); return n.length > 38 ? n.split(' | ')[0] : n; }
  function ok(r) {
    var q = clean(r.content);
    return r.rating === 5 && r.verified && !r.is_store && r.product && r.product.name && clean(r.author) &&
      q.length >= 40 && q.length <= 100 && /^[\x20-\x7E\u2018\u2019\u201C\u201D]+$/.test(q + r.author + r.product.name) && !/@|https?:|www\.|\d{6,}/i.test(q);
  }
  function pick(rs, n) {
    var out = [], p = {}, a = {}, u = {}, i, r, k;
    for (k = 0; k < 2; k++) for (i = 0; i < rs.length && out.length < n; i++) {
      r = rs[i];
      if (!ok(r) || a[clean(r.author)] || (!k && p[nm(r.product.name).split(' | ')[0]]) || u[r.id]) continue;
      u[r.id] = p[nm(r.product.name).split(' | ')[0]] = a[clean(r.author)] = 1;
      out.push([nm(r.product.name), clean(r.content), clean(r.author)]);
    }
    return out;
  }
  if (w.__onxRvTest) w.__onxRvTest = { pick: pick };

  function setNum(el, txt) {
    if (el.textContent === txt) return;
    if (el.textContent.length === txt.length) {
      var fs = parseFloat(getComputedStyle(el).fontSize), wd = el.getBoundingClientRect().width;
      if (fs && wd) el.style.width = wd / fs + 'em';
    } else el.style.width = '';
    el.textContent = txt;
  }
  function paintAgg() {
    if (!(C.a > 0 && C.n > 0)) return;
    var n = String(C.n).replace(/\B(?=(\d{3})+$)/g, ','), i, l = all('[data-onx-rating]'), c = all('[data-onx-count]');
    for (i = 0; i < l.length; i++) setNum(l[i], C.a.toFixed(1));
    for (i = 0; i < c.length; i++) setNum(c[i], n);
  }
  function paintCards() {
    var s = d.querySelector('[data-onx-rev-live]'), cards, i, f, t;
    if (!s || !C.c || !C.c.length) return;
    cards = s.querySelectorAll('.onx-rev__card');
    for (i = 0; i < cards.length && i < C.c.length; i++) {
      t = C.c[i];
      f = [cards[i].querySelector('.onx-rev__product'), cards[i].querySelector('.onx-rev__quote'), cards[i].querySelector('.onx-rev__name')];
      if (!f[0] || !f[1] || !f[2]) continue;
      f[0].textContent = t[0];
      if (f[0].scrollWidth > f[0].clientWidth + 1) f[0].textContent = t[0].split(' | ')[0];
      f[1].textContent = '“' + t[1] + '”';
      f[2].textContent = t[2];
    }
  }

  /* XMLHttpRequest, not fetch: another app on the store (Restock Rocket) wraps window.fetch and logs console errors,
     and re-sends the request, whenever a fetch fails or is aborted. A cross-origin XHR carries no cookies. */
  function load(limit, cb) {
    function fail() { C.f = Date.now(); save(); }
    var x = new XMLHttpRequest();
    x.onload = function () {
      try {
        var j = x.response, s = j && j.summary, a = s && s.star_rating, n = s && s.review_count;
        if (x.status !== 200 || !(a > 0 && a <= 5 && n > 0 && n < 1e6) || !Array.isArray(j.reviews)) return fail();
        cb(a, n, j.reviews);
      } catch (e) { fail(); }
    };
    x.onerror = x.ontimeout = fail;
    try { x.open('GET', U + limit); x.timeout = 3000; x.responseType = 'json'; x.send(); } catch (e) { fail(); }
  }

  function go() {
    if (done) return;
    done = 1;
    var home = !!d.querySelector('[data-onx-rev-live]'), needC = home && !fresh(C.ct), needA = !fresh(C.t);
    if (!(needA || needC) || (C.f && Date.now() - C.f < WAIT) || (navigator.connection && navigator.connection.saveData)) return;
    load(needC ? 50 : 1, function (a, n, rs) {
      C.a = a; C.n = n; C.t = Date.now(); C.f = 0;
      if (needC) { var c = pick(rs, 6); if (c.length > 3) { C.c = c; C.ct = C.t; } }
      save(); paintAgg(); paintCards();
    });
  }
  function after(fn) { if (d.readyState === 'complete') fn(); else w.addEventListener('load', fn, { once: true }); }
  function start() {
    paintAgg(); paintCards();
    if (fresh(C.t) && (fresh(C.ct) || !d.querySelector('[data-onx-rev-live]'))) return;
    var s = d.querySelector('[data-onx-rev-live]');
    if (s && w.IntersectionObserver) {
      ST = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { ST.disconnect(); after(go); } }, { rootMargin: '800px 0px' });
      ST.observe(s);
    }
    after(function () { (w.requestIdleCallback || function (f) { setTimeout(f, 200); })(go, { timeout: 3000 }); });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
